const aluminiumWorkerService = {
  title: "Aluminium Worker",
  icon: "🔩",
  shortDescription:
    "Aluminium fitting, partition support, frame work, and minor installation jobs.",
  longDescription:
    "Book aluminium work support for small fittings, channel adjustment, partition support, and minor frame corrections.",
  consultationNote:
    "Custom partitions or larger aluminium structure work may need inspection before pricing.",
  responsePromise:
    "Assignment depends on work type, section size, and fitter readiness.",
  warrantyPolicy:
    "Support depends on fitting condition, structure type, and completion scope.",
  subServices: [
    {
      id: "aluminium-channel-fix",
      title: "Channel / Frame Fix",
      icon: "📐",
      group: "Frames",
      description:
        "Minor channel correction, fitting adjustment, or loose aluminium support repair.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "aluminium-partition-adjustment",
      title: "Partition Adjustment",
      icon: "🧱",
      group: "Partitions",
      description:
        "Adjust aluminium partition alignment or support fittings where applicable.",
      basePrice: 799,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "aluminium-fitting-installation",
      title: "Aluminium Fitting Installation",
      icon: "🧰",
      group: "Installation",
      description:
        "Install minor aluminium accessory or section-based fittings.",
      basePrice: 799,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "aluminium-inspection",
      title: "Aluminium Work Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection visit for partitions, frames, aluminium modifications, or fitting estimates.",
      basePrice: 349,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default aluminiumWorkerService;